export default __webpack_public_path__ + "static/media/mobileSearch.bc6748fd.svg";